import { TirePartItem } from "../queries/useSearchTiresByVehicle";
import { WheelPartItem } from "../queries/useSearchWheelsByVehicle";

export const matchPartPricing = (
  partPricing: TirePartItem["partPricing"] | WheelPartItem["partPricing"],
  [min, max]: [number, number]
): boolean => {
  return Object.values(partPricing.primaryPart.price)
    .filter(Boolean)
    .some(({ contextList }) => {
      const displayPrice = Number(contextList.find(Boolean)?.displayPrice || 0);
      return displayPrice < max && displayPrice >= min;
    });
};
